/**
 * React Query hook for the long-term energy KPI mutation.
 *
 * Uses useMutation (not useQuery) because the KPI endpoint is a POST
 * request performing a computation — it is not a cacheable GET resource.
 */

import { useMutation } from '@tanstack/react-query';
import { kpisAPI } from '../api/kpis';

/**
 * Trigger a long-term KPI calculation.
 *
 * Usage:
 *   const mutation = useLongTermKPIs();
 *   const result = await mutation.mutateAsync(requestBody);
 *
 * @returns {import('@tanstack/react-query').UseMutationResult}
 */
export const useLongTermKPIs = () => {
  return useMutation({
    mutationFn: (params) => kpisAPI.longTerm(params),
  });
};
